import { useEffect } from 'react';
import { reportScreen } from '../../services/analyticsService';
import { Page } from '../../components/layout';
import ContentHeader from '../../components/ContentHeader';
import { Opportunities } from './Components/Opportunities';

const OpportunitiesPage = () => {
  useEffect(() => {
    reportScreen('opportunities_page');
  }, []);

  return (
    <Page className="opportunities-page">
      <ContentHeader
        title="Missed opportunities"
        subTitle="Track all the deals we sent you that you missed, see who ended up buying them, and how much they paid for each one."
      />
      <Opportunities />
    </Page>
  );
};

export default OpportunitiesPage;
